import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? 'https://api.everyvisit.app';
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

if (!supabaseAnonKey) {
  console.warn('VITE_SUPABASE_ANON_KEY is not configured.');
}

export const adminUrl = import.meta.env.VITE_ADMIN_URL ?? window.location.origin;
export const publicPreviewUrl = import.meta.env.VITE_PREVIEW_URL ?? 'https://preview.everyvisit.app';

const memoryStorage = new Map<string, string>();

function browserStores() {
  const stores: Storage[] = [];
  try {
    stores.push(window.localStorage);
  } catch {
    // Restrictive browser modes can disable localStorage.
  }
  try {
    stores.push(window.sessionStorage);
  } catch {
    // Safari private mode can block sessionStorage.
  }
  return stores;
}

const authStorage = {
  getItem: (key: string) => {
    if (memoryStorage.has(key)) return memoryStorage.get(key) ?? null;
    for (const store of browserStores()) {
      const value = store.getItem(key);
      if (value) return value;
    }
    return null;
  },
  setItem: (key: string, value: string) => {
    memoryStorage.set(key, value);
    for (const store of browserStores()) {
      try {
        store.setItem(key, value);
      } catch {
        // Restrictive browser modes can block storage writes.
      }
    }
  },
  removeItem: (key: string) => {
    memoryStorage.delete(key);
    for (const store of browserStores()) {
      try {
        store.removeItem(key);
      } catch {
        // Restrictive browser modes can block storage writes.
      }
    }
  },
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storage: authStorage,
  },
});
